export enum DDStatus {
  NOT_SETUP = 0,
  ACTIVE = 1,
  IN_ACTIVE = 2,
  ERROR = 3,
  PENDING = 4,
  OTHER = 5
}

export const PaymentStatus = {
  NOT_REQUIRED: { id: 0, label: 'Not Required' },
  AWAITING: { id: 1, label: 'Awaiting Payment' },
  FAILED: { id: 2, label: 'Payment Failed' },
  SUCCESS: { id: 3, label: 'Payment Successful' }
} as const

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus]

export const PaymentStatusById = Object.fromEntries(
  Object.values(PaymentStatus).map((status) => [status.id, status])
) as Record<PaymentStatus['id'], PaymentStatus>
